export default __webpack_public_path__ + "static/media/email_recuperation.74b70da9.svg";